import { render, staticRenderFns } from "./PluginList.vue?vue&type=template&id=d3df1972&scoped=true"
import script from "./PluginList.vue?vue&type=script&lang=js"
export * from "./PluginList.vue?vue&type=script&lang=js"
import style0 from "./PluginList.vue?vue&type=style&index=0&id=d3df1972&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3df1972",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d3df1972')) {
      api.createRecord('d3df1972', component.options)
    } else {
      api.reload('d3df1972', component.options)
    }
    module.hot.accept("./PluginList.vue?vue&type=template&id=d3df1972&scoped=true", function () {
      api.rerender('d3df1972', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/PluginList.vue"
export default component.exports